import NewHeroRegular from '../fonts/New_Hero_Regular.otf';
import NewHeroMedium from '../fonts/New_Hero_Medium.otf';
import NewHeroSemiBold from '../fonts/New_Hero_SemiBold.otf';
import NewHeroBold from '../fonts/New_Hero_Bold.otf';
import NewHeroSuper from '../fonts/New_Hero_Super.otf';

export default [
    {
        name: 'New Hero',
        files: [NewHeroRegular],
        options: {
            fontStyle: 'normal',
            fontWeight: '400',
        },
    },
    {
        name: 'New Hero',
        files: [NewHeroMedium],
        options: {
            fontStyle: 'normal',
            fontWeight: '500',
        },
    },
    {
        name: 'New Hero',
        files: [NewHeroSemiBold],
        options: {
            fontStyle: 'normal',
            fontWeight: '600',
        },
    },
    {
        name: 'New Hero',
        files: [NewHeroBold],
        options: {
            fontStyle: 'normal',
            fontWeight: '700',
        },
    },
    {
        name: 'New Hero',
        files: [NewHeroSuper],
        options: {
            fontStyle: 'normal',
            fontWeight: '900',
        },
    },
];
